import { createSlice } from '@reduxjs/toolkit';
import { initialAddTagsDrawerState } from './data/AddTagsDrawerState';

const slice = createSlice({
  name: 'add-tags-drawer',
  initialState: initialAddTagsDrawerState,
  reducers: {
    openAddTagsDrawer: (state) => {
      state.isAddTagsDrawerOpen = true;
    },
    closeAddTagsDrawer: (state) => {
      state.isAddTagsDrawerOpen = false;
    },
  },
});

export const { openAddTagsDrawer, closeAddTagsDrawer } = slice.actions;
export default slice.reducer;
